import { PauseButtonStroke, PlayButtonStroke } from 'assets/icons';
import styled, { DefaultTheme } from 'styled-components';
import { PhaseType } from 'types/package';

const getBorderColor = (phase: PhaseType, theme: DefaultTheme) => {
  switch (phase) {
    case '1':
      return theme.colors.phaseColors.phaseOneDefault;
    case '2':
      return theme.colors.phaseColors.phaseTwoDefault;
    case '3':
      return theme.colors.phaseColors.phaseThreeDefault;
  }
};

const StyledContainer = styled.div<{ isActive: boolean; phase: PhaseType }>`
  padding: 22px 16px;
  margin-bottom: 8px;
  position: relative;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  border: 2px solid
    ${({ isActive, phase, theme }) =>
      isActive ? getBorderColor(phase, theme) : 'transparent'};
  background: ${({ theme }) => theme.colors.neutralColors.darkerGray};
`;
const StyledHeading = styled.h2`
  font-size: 1.8rem;
  line-height: 2.4rem;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.colors.textColors.primaryLight};
`;
const StyledWordWrapper = styled.div`
  width: 80%;
`
const StyledDescription = styled.p`
  color: ${({ theme }) => theme.colors.textColors.secondaryLight};
  font-size: 1.2rem;
  line-height: 2.4rem;
`;
const StyledButton = styled.button`
  border: none;
  background: none;
  margin-right: 10px;
  cursor: pointer;
`;
type ChapterCardProps = {
  heading: string;
  description?: string;
  isActive: boolean;
  isPlaying: boolean;
  cardIndex: number;
  phase: PhaseType;
  handleClick: (cardIndex: number) => void;
};

const ChapterCard = ({
  heading,
  description,
  isActive,
  isPlaying,
  handleClick,
  cardIndex,
  phase,
}: ChapterCardProps) => {
  return (
    <StyledContainer isActive={isActive} phase={phase}>
      <StyledWordWrapper>
      <StyledHeading>{heading}</StyledHeading>
      <StyledDescription>{description}</StyledDescription>
        </StyledWordWrapper>
      <StyledButton type="button" onClick={() => handleClick(cardIndex)}>
        {isPlaying ? (
          <PauseButtonStroke color="white" />
        ) : (
          <PlayButtonStroke color="white" />
        )}
      </StyledButton>

    </StyledContainer>
  );
};

export default ChapterCard;
